module.exports = __webpack_public_path__ + "assets/icon_delete_new.d4c56163.svg";